import Add from '@shared/assets/images/add.svg?raw'
import ArrowRightAlt from '@shared/assets/images/arrow_right_alt.svg?raw'
import Autorenew from '@shared/assets/images/autorenew.svg?raw'
import VideoMute from '@shared/assets/images/cam-off.svg?raw'
import Comment from '@shared/assets/images/comment.svg?raw'
import CompareArrows from '@shared/assets/images/compare_arrows.svg?raw'
import EmojiPeople from '@shared/assets/images/emoji_people.svg?raw'
import FastForward from '@shared/assets/images/fast_forward.svg?raw'
import HangIcon from '@shared/assets/images/hang-icon.svg?raw'
import MailOutlineIcon from '@shared/assets/images/mail_outline.svg?raw'
import PlayArrow from '@shared/assets/images/play_arrow.svg?raw'
import ResendIcon from '@shared/assets/images/resend-icon.svg?raw'
import SendIcon from '@shared/assets/images/send-icon.svg?raw'
import Send from '@shared/assets/images/send.svg?raw'
import SwitchCamera from '@shared/assets/images/switch-cam.svg?raw'
import Troubleshooting from '@shared/assets/images/troubleshooting.svg?raw'

import {
  alarmClockIcon,
  angleIcon,
  arrowIcon,
  bellIcon,
  calendarIcon,
  cameraIcon,
  chatBubbleIcon,
  checkboxListIcon,
  checkCircleIcon,
  checkIcon,
  circleArrowIcon,
  ClarityIcons,
  compassIcon,
  downloadIcon,
  ellipsisHorizontalIcon,
  ellipsisVerticalIcon,
  envelopeIcon,
  errorStandardIcon,
  fastForwardIcon,
  fileIcon,
  fileZipIcon,
  filterIcon,
  formIcon,
  happyFaceIcon,
  headphonesIcon,
  helpIcon,
  infoCircleIcon,
  infoStandardIcon,
  logoutIcon,
  microphoneIcon,
  microphoneMuteIcon,
  paperclipIcon,
  pictureIcon,
  playIcon,
  plusIcon,
  printerIcon,
  refreshIcon,
  searchIcon,
  syncIcon,
  timesCircleIcon,
  timesIcon,
  twoWayArrowsIcon,
  uploadCloudIcon,
  videoCameraIcon,
  windowCloseIcon,
  worldIcon,
  wrenchIcon,
} from '@cds/core/icon'
import CalendarPc from '@pc/assets/images/calendar_pc.svg?raw'
import Fingerprint from '@pc/assets/images/fingerprint.svg?raw'

export default () => {
  ClarityIcons.addIcons(
    errorStandardIcon,
    plusIcon,
    cameraIcon,
    refreshIcon,
    pictureIcon,
    plusIcon,
    formIcon,
    headphonesIcon,
    circleArrowIcon,
    twoWayArrowsIcon,
    fastForwardIcon,
    envelopeIcon,
    chatBubbleIcon,
    cameraIcon,
    uploadCloudIcon,
    windowCloseIcon,
    syncIcon,
    downloadIcon,
    checkCircleIcon,
    calendarIcon,
    searchIcon,
    videoCameraIcon,
    checkboxListIcon,
    wrenchIcon,
    microphoneMuteIcon,
    microphoneIcon,
    infoCircleIcon,
    filterIcon,
    bellIcon,
    playIcon,
    fileIcon,
    printerIcon,
    logoutIcon,
    timesCircleIcon,
    angleIcon,
    worldIcon,
    helpIcon,
    ellipsisHorizontalIcon,
    ellipsisVerticalIcon,
    checkIcon,
    paperclipIcon,
    happyFaceIcon,
    timesIcon,
    arrowIcon,
    alarmClockIcon,
    infoStandardIcon,
    compassIcon,
    fileZipIcon,

    ['mail_outline', MailOutlineIcon],
    ['arrow_right_alt', Add],
    ['arrow_right_alt', ArrowRightAlt],
    ['autorenew', Autorenew],
    ['comment', Comment],
    ['emoji_people', EmojiPeople],
    ['fast_forward', FastForward],
    ['play_arrow', PlayArrow],
    ['send', Send],
    ['compare_arrows', CompareArrows],
    ['calendar_pc', CalendarPc],
    ['fingerprint', Fingerprint],
    ['resend', ResendIcon],
    ['send', SendIcon],
    ['switch-camera', SwitchCamera],
    ['video-mute', VideoMute],
    ['hang', HangIcon],
    ['troubleshooting', Troubleshooting]
  )
}
